import React from "react";
import {Select} from "antd";

const {Option} = Select

export const triggerTypeOptions = [<>
    <Option key={1} value={"EVERY"}>{"Every n minutes"}</Option>
    <Option key={2} value={"AT"}>{"Daily"}</Option>
    <Option key={3} value={"SUN"}>{"Relative to the Sun"}</Option>
    <Option key={4} value={"WEEKLY"}>{"Weekly"}</Option>
    <Option key={5} value={"MONTHLY"}>{"Monthly"}</Option>
</>]

export const twilightTypeOptions = [<>
    <Option key={0} value={null}>{"VISUAL"}</Option>
    <Option key={1} value={"CIVIL"}>{"CIVIL"}</Option>
    <Option key={2} value={"NAUTICAL"}>{"NAUTICAL"}</Option>
    <Option key={3} value={"ASTRONOMICAL"}>{"ASTRONOMICAL"}</Option>
</>]

export const limitedToOptions = [<>
    <Option key={1} value={"NIGHT"}>{"nighttime"}</Option>
    <Option key={2} value={"DAY"}>{"daytime"}</Option>
    <Option key={3} value={"CIVIL_NIGHT"}>{"civil nighttime"}</Option>
    <Option key={4} value={"CIVIL_DAY"}>{"civil daytime"}</Option>
    <Option key={5} value={"NAUTICAL_NIGHT"}>{"nautical nighttime"}</Option>
    <Option key={5} value={"NAUTICAL_DAY"}>{"nautical daytime"}</Option>
    <Option key={5} value={"ASTRONOMICAL_NIGHT"}>{"astronomical nighttime"}</Option>
    <Option key={5} value={"ASTRONOMICAL_DAY"}>{"astronomical daytime"}</Option>
</>]

export const sunPositionOptions = [<>
    <Option key={1} value={"SUNSET"}>{"SUNSET"}</Option>
    <Option key={2} value={"MIDNIGHT"}>{"MIDNIGHT"}</Option>
    <Option key={3} value={"SUNRISE"}>{"SUNRISE"}</Option>
</>]

export const triggerDayOfMonth = [<>
    <Option key={1} value={"1"}>1</Option>
    <Option key={2} value={"2"}>2</Option>
    <Option key={3} value={"3"}>3</Option>
    <Option key={4} value={"4"}>4</Option>
    <Option key={5} value={"5"}>5</Option>
    <Option key={1} value={"6"}>6</Option>
    <Option key={2} value={"7"}>7</Option>
    <Option key={3} value={"8"}>8</Option>
    <Option key={4} value={"9"}>9</Option>
    <Option key={5} value={"10"}>10</Option>
    <Option key={1} value={"11"}>11</Option>
    <Option key={2} value={"12"}>12</Option>
    <Option key={3} value={"13"}>13</Option>
    <Option key={4} value={"14"}>14</Option>
    <Option key={5} value={"15"}>15</Option>
    <Option key={1} value={"16"}>16</Option>
    <Option key={2} value={"17"}>17</Option>
    <Option key={3} value={"18"}>18</Option>
    <Option key={4} value={"19"}>19</Option>
    <Option key={5} value={"20"}>20</Option>
    <Option key={1} value={"21"}>21</Option>
    <Option key={2} value={"22"}>22</Option>
    <Option key={3} value={"23"}>23</Option>
    <Option key={4} value={"24"}>24</Option>
    <Option key={5} value={"25"}>25</Option>
    <Option key={1} value={"26"}>26</Option>
    <Option key={2} value={"27"}>27</Option>
    <Option key={3} value={"28"}>28</Option>
    <Option key={4} value={"29"}>29</Option>
    <Option key={5} value={"30"}>30</Option>
    <Option key={5} value={"31"}>31</Option>
</>]